module.exports = __webpack_public_path__ + "static/0-76088fef00dd1c459ea77f14cbd8efb7.jpg";